import { createApp } from 'vue';
import SimpleColumnTableBlock from './SimpleColumnTableBlock.vue';
import "./SimpleColumnTableBlock.scss";

function mountRelatedContentContainerBlocks() {
	const blocks = document.querySelectorAll('[data-feature="simple-table"]');

	blocks.forEach((block) => {
		const app = createApp({
			name: 'SimpleColumnTableBlockApp',
		});

		app.component('simple-column-table-block', SimpleColumnTableBlock);
		app.mount(block);
	})
}

mountRelatedContentContainerBlocks();